import { useState } from "react";
import { Copy, Check, Gift, Clock, Star, Zap, Shield } from "lucide-react";
import { Button } from "../components/ui/button";

const promoCodes = [
  {
    id: 1,
    casino: "5Gringos Casino",
    logo: "https://images.unsplash.com/photo-1596838132731-3301c3fd4317?w=200",
    code: "SPIRO500",
    bonus: "100% up to £500 + 200 Free Spins",
    description: "Exclusive PlaySpiro code — not available anywhere else!",
    expiry: "2026-12-31",
    wagering: "35x",
    minDeposit: "£20",
    color: "#f59e0b",
    affiliate: "https://fgrns.lynmonkel.com/?mid=389405_2246229",
    tag: "EXCLUSIVE",
    rating: 4.9,
  },
  {
    id: 2,
    casino: "HellSpin Casino",
    logo: "https://images.unsplash.com/photo-1596838132731-3301c3fd4317?w=200",
    code: "HELLSPIRO",
    bonus: "CA$5200 + 150 Free Spins",
    description: "Massive welcome package exclusively for PlaySpiro visitors",
    expiry: "2026-06-30",
    wagering: "40x",
    minDeposit: "CA$20",
    color: "#ef4444",
    affiliate: "https://top.aglobally.com/redirect.aspx?pid=4960&bid=1466&lpid=6",
    tag: "HOT",
    rating: 4.8,
  },
  {
    id: 3,
    casino: "Vulkan Vegas",
    logo: "https://images.unsplash.com/photo-1605870445919-838d190e8e1b?w=200",
    code: "VVSPIRO150",
    bonus: "CA$1,500 + 150 Free Spins",
    description: "Approved by Casino Guru — top rated bonus for Canadian players",
    expiry: "2026-09-30",
    wagering: "30x",
    minDeposit: "CA$10",
    color: "#a855f7",
    affiliate: "https://vulkanvegas-promo.com/l/69b09766a52f4256800c1002",
    tag: "TOP RATED",
    rating: 4.7,
  },
  {
    id: 4,
    casino: "Mostbet",
    logo: "https://images.unsplash.com/photo-1567443024551-f3e3cc2be870?w=200",
    code: "MOST400",
    bonus: "CAD 3,400 + 400 Free Spins",
    description: "400 free spins exclusive deal for new Canadian players",
    expiry: "2026-08-31",
    wagering: "35x",
    minDeposit: "CAD $10",
    color: "#22c55e",
    affiliate: "https://tvohyjpmb.com/sport/casino/ca_en/coin_volcano2/",
    tag: "400 FS",
    rating: 4.6,
  },
  {
    id: 5,
    casino: "Fairspin",
    logo: "https://images.unsplash.com/photo-1606167668584-78701c57f13d?w=200",
    code: "FAIRPLAY200",
    bonus: "200% up to 2500 CAD + 50 FS",
    description: "Crypto-friendly casino with 10% weekly cashback",
    expiry: "2026-12-31",
    wagering: "30x",
    minDeposit: "CA$20",
    color: "#3b82f6",
    affiliate: "https://fairspin-h.click/62639/8406?l=2&utm_source=slot&utm_content=fb",
    tag: "CRYPTO",
    rating: 4.7,
  },
  {
    id: 6,
    casino: "LeoVegas",
    logo: "https://images.unsplash.com/photo-1511512578047-dfb367046420?w=200",
    code: "LEOSPIRO",
    bonus: "$1,000 + 200 Free Spins",
    description: "King of Mobile — best casino app experience",
    expiry: "2026-10-31",
    wagering: "35x",
    minDeposit: "$10",
    color: "#f97316",
    affiliate: "https://ntrfr.leovegas.com/redirect.aspx?pid=3658838&bid=18372",
    tag: "MOBILE",
    rating: 4.9,
  },
];

export default function PromoCodes() {
  const [copied, setCopied] = useState(null);
  const [filter, setFilter] = useState("all");

  const copyCode = (id, code) => {
    navigator.clipboard.writeText(code);
    setCopied(id);
    setTimeout(() => setCopied(null), 2000);
  };

  const daysLeft = (expiry) => {
    const diff = new Date(expiry) - new Date();
    return Math.max(0, Math.ceil(diff / (1000*60*60*24)));
  };

  return (
    <div style={{minHeight:"100vh",padding:"40px 16px"}}>
      <div style={{maxWidth:"1100px",margin:"0 auto"}}>
        
        {/* Header */}
        <div style={{textAlign:"center",marginBottom:"48px"}}>
          <div style={{display:"inline-flex",alignItems:"center",gap:"8px",background:"rgba(168,85,247,0.15)",border:"1px solid rgba(168,85,247,0.3)",borderRadius:"100px",padding:"6px 16px",marginBottom:"16px"}}>
            <Gift style={{width:"14px",height:"14px",color:"#a855f7"}}/>
            <span style={{color:"#a855f7",fontSize:"0.8rem",fontWeight:"600"}}>EXCLUSIVE CODES</span>
          </div>
          <h1 style={{color:"white",fontSize:"clamp(1.8rem,4vw,2.8rem)",fontWeight:"bold",marginBottom:"12px"}}>
            🎁 Exclusive Promo Codes
          </h1>
          <p style={{color:"rgba(255,255,255,0.5)",fontSize:"1rem",maxWidth:"500px",margin:"0 auto"}}>
            PlaySpiro exclusive codes — higher bonuses than signing up directly!
          </p>
        </div>

        {/* Stats Bar */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:"12px",marginBottom:"40px"}}>
          {[
            {icon:"🎰",label:"Active Codes",value:promoCodes.length},
            {icon:"💰",label:"Max Bonus",value:"CA$5,200"},
            {icon:"🎡",label:"Max Free Spins",value:"400 FS"},
            {icon:"✅",label:"Verified Today",value:"All Codes"},
          ].map((s,i) => (
            <div key={i} style={{background:"rgba(168,85,247,0.08)",border:"1px solid rgba(168,85,247,0.2)",borderRadius:"12px",padding:"16px",textAlign:"center"}}>
              <div style={{fontSize:"1.5rem",marginBottom:"4px"}}>{s.icon}</div>
              <div style={{color:"white",fontWeight:"bold",fontSize:"1.1rem"}}>{s.value}</div>
              <div style={{color:"rgba(255,255,255,0.4)",fontSize:"0.75rem"}}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Promo Cards */}
        <div style={{display:"grid",gap:"20px"}}>
          {promoCodes.map((promo) => (
            <div key={promo.id} style={{background:"linear-gradient(135deg,rgba(26,5,51,0.9),rgba(45,10,94,0.9))",border:`1px solid ${promo.color}40`,borderRadius:"20px",padding:"24px",position:"relative",overflow:"hidden",transition:"transform 0.2s,box-shadow 0.2s"}}
              onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow=`0 12px 40px ${promo.color}30`;}}
              onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}>
              
              {/* Tag */}
              <div style={{position:"absolute",top:"16px",right:"16px",background:promo.color,color:"black",borderRadius:"100px",padding:"3px 10px",fontSize:"0.65rem",fontWeight:"bold",letterSpacing:"0.5px"}}>
                {promo.tag}
              </div>

              {/* Left glow */}
              <div style={{position:"absolute",left:0,top:0,bottom:0,width:"4px",background:promo.color,borderRadius:"4px 0 0 4px"}}/>

              <div style={{display:"flex",gap:"20px",alignItems:"center",flexWrap:"wrap"}}>
                {/* Casino Info */}
                <div style={{display:"flex",alignItems:"center",gap:"14px",minWidth:"200px"}}>
                  <img src={promo.logo} alt={promo.casino} style={{width:"56px",height:"56px",borderRadius:"12px",objectFit:"cover",border:`2px solid ${promo.color}60`}} onError={e=>e.target.style.display="none"} />
                  <div>
                    <div style={{color:"white",fontWeight:"bold",fontSize:"1rem"}}>{promo.casino}</div>
                    <div style={{display:"flex",gap:"2px",marginTop:"3px"}}>
                      {[1,2,3,4,5].map(s=><span key={s} style={{color:s<=Math.round(promo.rating)?"#ffd700":"rgba(255,255,255,0.2)",fontSize:"0.75rem"}}>★</span>)}
                    </div>
                    <div style={{color:"rgba(255,255,255,0.4)",fontSize:"0.7rem",marginTop:"2px"}}>
                      <Clock style={{width:"10px",height:"10px",display:"inline",marginRight:"3px"}}/>
                      {daysLeft(promo.expiry)} days left
                    </div>
                  </div>
                </div>

                {/* Bonus Info */}
                <div style={{flex:1,minWidth:"180px"}}>
                  <div style={{color:promo.color,fontWeight:"bold",fontSize:"1.05rem",marginBottom:"4px"}}>{promo.bonus}</div>
                  <div style={{color:"rgba(255,255,255,0.5)",fontSize:"0.8rem",marginBottom:"8px"}}>{promo.description}</div>
                  <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
                    <span style={{background:"rgba(255,255,255,0.05)",borderRadius:"6px",padding:"2px 8px",color:"rgba(255,255,255,0.5)",fontSize:"0.7rem"}}>Wagering: {promo.wagering}</span>
                    <span style={{background:"rgba(255,255,255,0.05)",borderRadius:"6px",padding:"2px 8px",color:"rgba(255,255,255,0.5)",fontSize:"0.7rem"}}>Min: {promo.minDeposit}</span>
                  </div>
                </div>

                {/* Code + CTA */}
                <div style={{display:"flex",flexDirection:"column",gap:"10px",alignItems:"center",minWidth:"180px"}}>
                  <div style={{background:"rgba(0,0,0,0.3)",border:`2px dashed ${promo.color}60`,borderRadius:"10px",padding:"10px 16px",display:"flex",alignItems:"center",gap:"10px",cursor:"pointer",width:"100%",justifyContent:"space-between"}}
                    onClick={() => copyCode(promo.id, promo.code)}>
                    <span style={{color:"white",fontWeight:"bold",fontSize:"1rem",letterSpacing:"1px"}}>{promo.code}</span>
                    {copied === promo.id
                      ? <Check style={{width:"16px",height:"16px",color:"#22c55e"}}/>
                      : <Copy style={{width:"16px",height:"16px",color:"rgba(255,255,255,0.4)"}}/>
                    }
                  </div>
                  <a href={promo.affiliate} target="_blank" rel="noopener noreferrer" style={{width:"100%",textDecoration:"none"}}>
                    <button style={{width:"100%",background:`linear-gradient(135deg,${promo.color},${promo.color}cc)`,color:"black",border:"none",borderRadius:"10px",padding:"10px",fontWeight:"bold",fontSize:"0.9rem",cursor:"pointer"}}>
                      Claim Bonus →
                    </button>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <div style={{marginTop:"40px",padding:"16px",background:"rgba(255,255,255,0.03)",borderRadius:"12px",textAlign:"center"}}>
          <Shield style={{width:"16px",height:"16px",color:"rgba(255,255,255,0.3)",display:"inline",marginRight:"6px"}}/>
          <span style={{color:"rgba(255,255,255,0.3)",fontSize:"0.75rem"}}>18+ only. Gamble responsibly. T&Cs apply. Codes verified as of today.</span>
        </div>
      </div>
    </div>
  );
}
